module.exports = __webpack_public_path__ + "03_hige_black.597929c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/03_hige_black.png
// module id = vCus
// module chunks = 0